import React, { useState, useRef } from "react";
import { GoogleMap, useJsApiLoader } from "@react-google-maps/api";
import LocationMarker from "./LocationMarker";
import LocationInfoBox from "./LocationInfoBox";
import DropdownList from "./DropdownList";

const containerStyle = {
  width: "100vw",
  height: "100vh",
  position: "relative",
};

const Map = ({ eventData}) => {
  const [locationInfo, setLocationInfo] = useState(null);
  const [openModal, setOpenModal] = useState(true);
  const [optionValue, setOptionValue] = useState("");
  const categories = [];
  eventData.forEach((ev, index) => {
    categories.push(ev.categories[0].title);
  });
  const category = [...new Set(categories)];
  let markers = eventData.map((ev, index) => {
    if (ev.categories[0].title === optionValue) {
      return (
        <div key={index}>
          {ev.geometries.map(function (item, i) {
            return (
              <LocationMarker
                key={`${index}_${i}`}
                lat={item.coordinates[1]}
                lng={item.coordinates[0]}
                icon={ev.categories[0].title}
                onClick={() => {
                  setOpenModal(true);
                  setLocationInfo({ id: ev.id, title: ev.title });
                }}
              ></LocationMarker>
            );
          })}
        </div>
      );
    }
    return null;
  });

  const handleChange = (e) => {
    setOptionValue(e.value);
  };
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: process.env.REACT_APP_API_KEY,
  });

  const mapRef = useRef(null);
  const [position] = useState({
    lat: 0,
    lng: 0,
  });
  function handleLoad(map) {
    mapRef.current = map;
  }

  return isLoaded ? (
    <div id="map">
      <DropdownList category={category} onChange={handleChange}></DropdownList>
      <GoogleMap
        mapContainerStyle={containerStyle}
        zoom={2}
        center={position}
        onLoad={handleLoad}
        options={{
          minZoom: 2,
          streetViewControl: false,
          mapTypeControl: false,
        }}
      >
        {markers}
      </GoogleMap>
      {locationInfo && openModal && (
        <LocationInfoBox info={locationInfo} closeModal={setOpenModal} />
      )}
    </div>
  ) : (
    <></>
  );
};
Map.defaultProps = {
  center: {
    lat: 42.3265,
    lng: -122.8756,
  },
  zoom: 6,
};

export default Map;
